import { isArray } from 'lodash'

const ImageLoader = {
    /**
     * Preload one or multiple images and wait until they are all done loading.
     *
     * @param images - A single image URL or an array of image URLs.
     * @returns A Promise that resolves when all images are loaded.
     */
    load(images: string | string[]): Promise<HTMLImageElement | HTMLImageElement[]> {
        if (isArray(images)) {
            return Promise.all(images.map(image => this.load(image))) as Promise<HTMLImageElement[]>
        }

        return new Promise((resolve, reject) => {
            if (!images) {
                reject(new Error('No image source provided'))
                return
            }

            const img = new Image()

            /**
             * Skip setting crossOrigin for base64 images
             * This was causing an error in Safari.
             */
            if (!images.startsWith('data:image')) {
                img.crossOrigin = 'anonymous'
            }

            img.onload = () => resolve(img)
            img.onerror = () => reject(new Error(`Failed to load image: ${images}`))
            img.src = images
        })
    },
}

export default ImageLoader
